import React from "react";
import config from "./lib/config";

const functionName = config.apiName || "myFunc";

export function EditCode(props) {
  const { showFunction, tabCodeEntry, functionCodePath } = {
    showFunction: true,
    tabCodeEntry: "tabs/src/index.jsx",
    functionCodePath: `api/${functionName}/index.js`,
    ...props,
  };
  return (
    <div>
      {/* <h2>Change this code</h2> */}
      <h2>Tips</h2>
      {/* <p>
        The front end is a <code>create-react-app</code>. The entry point is{" "}
        <code>{tabCodeEntry}</code>. Just save any file and this page will reload automatically.
      </p> */}
      <p>Unvaliable for Mobile Client! </p>
      <p>lf you have any quesions, please reply ticket or email to helpdesk@x-epic.com</p>


      {showFunction && (
        <p>
          This app contains an Azure Functions backend. Find the code in{" "}
          <code>{functionCodePath}</code>
        </p>
      )}
    </div>
  );
}
